module.exports = __webpack_public_path__ + "./fonts/montserrat-latin-600.f6dc6096f48956908c1787d9a722570a.woff";